import { render, staticRenderFns } from "./RecreationWidget.vue?vue&type=template&id=64c828b1"
import script from "./RecreationWidget.vue?vue&type=script&lang=js"
export * from "./RecreationWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports